<form class="mt-4 flex flex-col gap-6" [formGroup]="form">
  <div class="flex flex-col gap-4">
    <div class="mb-4 flex flex-col gap-3">
      <mat-slide-toggle formControlName="enabled">Enabled</mat-slide-toggle>
      <mat-slide-toggle formControlName="testMode">
        Test mode
      </mat-slide-toggle>
      <mat-slide-toggle formControlName="addACCAsPending">
        Manually confirm ACC payments
      </mat-slide-toggle>
      <pr-information-box>
        When ACC reports a payment, it will be held as pending so you can
        confirm receipt against your remittance advice before it's marked as
        paid. With this off, ACC payments are completed automatically.
      </pr-information-box>
    </div>

    <div class="font-bold">Practice Provider Details</div>

    <pr-information-box>
      Enter the Practice's ACC credentials below.<br />
      Individual Staff provider information can be configured in the Staff Edit
      pages.
    </pr-information-box>

    <div class="-mb-4 flex gap-4">
      <mat-form-field class="flex-1">
        <mat-label>Vendor ID</mat-label>
        <input matInput formControlName="vendorId" />
        @if (form.controls.vendorId.hasError('minlength')) {
          <mat-error>Vendor ID must be 6 characters long</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Provider ID</mat-label>
        <input matInput formControlName="providerId" />
        @if (form.controls.providerId.hasError('minlength')) {
          <mat-error>Provider ID must be 6 characters long</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="-mb-4 flex gap-4">
      <mat-form-field class="flex-1">
        <mat-label>Facility ID</mat-label>
        <input matInput formControlName="facilityId" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Vendor GST Number</mat-label>
        <input matInput formControlName="vendorGST" />
        @if (form.controls.vendorGST.hasError('pattern')) {
          <mat-error>GST Number must contain only numbers</mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <div class="font-bold">PFX Certificate</div>

    <a
      class="text-primary-500 -mt-3 inline-flex items-center gap-2 text-xs opacity-90"
      href="https://www.healthlink.co.nz/help-and-support/digital-certificates/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>How to acquire a HealthLink Digital Certificate</span>
      <mat-icon class="icon-xs">open_in_new</mat-icon>
    </a>

    <pt-file-upload-to-storage
      [path]="storagePath()"
      [acceptExtensions]="pfxExtensions"
      [multiple]="false"
      (uploadStarted)="uploadPfxFile($event)"
      (filesRejected)="notifyPfxFileRejected()"
    >
      <div class="flex flex-col items-center gap-1 text-xs text-gray-700">
        @if (form.controls.pfxFilePath.value) {
          <div class="flex items-center gap-2">
            <span class="font-medium">
              File uploaded:
              {{ form.controls.pfxFilePath.value | map: getPfxFileName }}
            </span>
          </div>
          <div class="italic">Drop a new file or click here to replace.</div>
        }
      </div>
    </pt-file-upload-to-storage>

    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-label>PFX Passphrase</mat-label>
      <input matInput formControlName="pfxPassphrase" type="password" />
    </mat-form-field>
  </div>

  <div class="flex flex-col gap-4">
    <div class="font-bold">Patient Form Notifications</div>

    <pr-information-box>
      Notify patients via email, SMS, or both. Choose a patient template for the
      message, or a default template will be used.
    </pr-information-box>

    <div class="flex gap-4">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Patient Email Template</mat-label>
        <mat-select
          formControlName="formNotificationEmailTemplate"
          [compareWith]="compareTemplates"
        >
          <mat-option [value]="undefined">None (default template)</mat-option>
          @for (
            template of patientEmailTemplates$ | async;
            track template.ref.path
          ) {
            <mat-option [value]="template.ref">
              {{ template.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Patient SMS Template</mat-label>
        <mat-select
          formControlName="formNotificationSmsTemplate"
          [compareWith]="compareTemplates"
        >
          <mat-option [value]="undefined">None (default template)</mat-option>
          @for (
            template of patientSmsTemplates$ | async;
            track template.ref.path
          ) {
            <mat-option [value]="template.ref">
              {{ template.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <pt-buttons-container>
    <button
      mat-flat-button
      color="primary"
      [disabled]="saveDisabled$ | async"
      (click)="save()"
    >
      Save
    </button>
  </pt-buttons-container>
</form>
